export default __webpack_public_path__ + "static/media/PrispekHeader.4bc14c92.png";